import React, { createContext, useCallback, useContext, useEffect, useState } from 'react';
import api from '../lib/api';
import { useAuth } from './AuthContext';

const SubscriptionContext = createContext(null);

export const SubscriptionProvider = ({ children }) => {
  const { user } = useAuth();
  const [status, setStatus] = useState({ is_premium: true, in_trial: false, trial_days_left: 0, reason: 'unknown' });
  const [loading, setLoading] = useState(false);
  const [paywall, setPaywall] = useState({ open: false, feature: null });

  const refresh = useCallback(async () => {
    if (!user) return;
    setLoading(true);
    try {
      const { data } = await api.get('/subscription/status');
      setStatus(data);
    } catch { /* ignore */ }
    finally { setLoading(false); }
  }, [user]);

  useEffect(() => { refresh(); }, [refresh]);

  const requirePremium = useCallback((_feature) => {
    // Demo mode: all features unlocked for everyone — never show the paywall.
    return true;
  }, []);

  const closePaywall = () => setPaywall({ open: false, feature: null });

  return (
    <SubscriptionContext.Provider value={{ status, loading, refresh, requirePremium, paywall, closePaywall }}>
      {children}
    </SubscriptionContext.Provider>
  );
};

export const useSubscription = () => useContext(SubscriptionContext);
